import React, { Fragment } from 'react';

export default {
  units: [
    {
      id: 'TH1',
      mockup: (
        <g id="th1" transform="translate(357.000000, 185.000000)">
          <polygon
            id="fill-th1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="48.9257994 11.4238078 35.7488615 11.4238078 35.7488615 0.351519716 5.24669045 0.351519716 5.24669045 26.3393694 5.97874255 26.3393694 5.97874255 66.6022352 0.854377818 66.6022352 0.854377818 79.413147 18.0576023 79.413147 18.0576023 70.5065131 27.9403057 70.5065131 27.9403057 69.4084349 49.2918254 69.4084349 49.2918254 44.7016764 49.1088124 44.7016764"
          />
          <text
            id="TH1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.3076008" y="38.6922522">
              TH1
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH2',
      mockup: (
        <g id="th2" transform="translate(405.000000, 185.000000)">
          <polygon
            id="fill-th2"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.5809777 11.4238078 31.6719877 11.4238078 31.6719877 0.351519716 1.16981672 0.351519716 1.16981672 11.5153143 0.986803693 11.5153143 0.986803693 44.7321786 1.16981672 44.7321786 1.16981672 69.4389371 45.6419821 69.4389371"
          />
          <text
            id="TH2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.3527357" y="38.6922522">
              TH2
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH3',
      mockup: (
        <g id="th3" transform="translate(449.000000, 185.000000)">
          <polygon
            id="fill-th3"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="46.2361561 11.4238078 31.412101 11.4238078 31.412101 0.351519716 0.909929967 0.351519716 0.909929967 11.5153143 1.64198207 11.5153143 1.64198207 69.4694393 46.2971605 69.4694393"
          />
          <text
            id="TH3"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.7638967" y="38.6922522">
              TH3
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH4',
      mockup: (
        <g id="th4" transform="translate(36.000000, 367.000000)">
          <polygon
            id="fill-th4"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="46.7857995 9.14259947 41.7834435 9.14259947 41.7834435 0.724000266 0.788525624 0.724000266 0.788525624 73.7461977 30.9856749 73.7461977 30.9856749 57.4580384 46.9078082 57.4580384"
          />
          <text
            id="TH4"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="11.0390206" y="31.5611987">
              TH4
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH5',
      mockup: (
        <g id="th5" transform="translate(77.000000, 352.000000)">
          <polygon
            id="fill-th5"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="49.6479215 0.533919097 0.844447822 0.533919097 0.844447822 24.1425995 5.96881255 24.1425995 5.96881255 72.4580384 3.58964321 72.4580384 3.58964321 88.7461977 34.0918142 88.7461977 34.0918142 72.4580384 49.8309345 72.4580384"
          />
          <text
            id="TH5"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.6336912" y="46.5611987">
              TH5
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH6',
      mockup: (
        <g id="th6" transform="translate(124.000000, 352.000000)">
          <polygon
            id="fill-th6"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="46.3880347 0.533919097 2.64792146 0.533919097 2.64792146 72.4580384 0.26875212 72.4580384 0.26875212 88.7461977 30.7709231 88.7461977 30.7709231 72.4580384 46.4185369 72.4580384"
          />
          <text
            id="TH6"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="11.1292905" y="46.5611987">
              TH6
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH7',
      mockup: (
        <g id="th7" transform="translate(168.000000, 352.000000)">
          <polygon
            id="fill-th7"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.9451349 13.89387 42.8949178 13.89387 42.8949178 0.533919097 2.41853688 0.533919097 2.41853688 72.4580384 0.222380565 72.4580384 0.222380565 88.7461977 30.7245516 88.7461977 30.7245516 72.4580384 45.9756371 72.4580384"
          />
          <text
            id="TH7"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="11.5404515" y="46.5611987">
              TH7
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH8',
      mockup: (
        <g id="th8" transform="translate(211.000000, 365.000000)">
          <polygon
            id="fill-th8"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="47.0512742 0.893870005 2.94513493 0.893870005 2.94513493 59.4580384 0.931991642 59.4580384 0.931991642 75.7461977 31.312154 75.7461977 31.312154 59.4580384 47.0512742 59.4580384"
          />
          <text
            id="TH8"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="12.5855865" y="33.5611987">
              TH8
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH9',
      mockup: (
        <g id="th9" transform="translate(257.000000, 359.000000)">
          <polygon
            id="fill-th9"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="56.1381951 24.2801075 39.3009967 24.2801075 39.3009967 0.854440142 20.1761355 0.854440142 20.1761355 10.1881045 0.959767716 10.1881045 0.959767716 65.4580384 16.2108532 65.4580384 16.2108532 81.7461977 44.0288332 81.7461977 44.0288332 70.3688879 56.2297016 70.3688879"
          />
          <text
            id="TH9"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="15.8770949" y="39.5611987">
              TH9
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH13',
      mockup: (
        <g id="th13" transform="translate(440.000000, 366.000000)">
          <polygon
            id="fill-th13"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="66.5829637 10.3256125 46.6345439 10.3256125 46.6345439 0.442909083 2.52840458 0.442909083 2.52840458 58.397034 0.698274318 58.397034 0.698274318 74.6851934 31.2004453 74.6851934 31.2004453 58.4580384 44.5908984 58.4580384 44.5908984 41.62084 66.5524616 41.62084"
          />
          <text
            id="TH13"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.192121" y="32.5611987">
              TH13
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH10',
      mockup: (
        <g id="th10" transform="translate(296.000000, 359.000000)">
          <polygon
            id="fill-th10"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="57.2180478 5.97880487 57.0350348 5.97880487 57.0350348 4.51470067 19.3343514 4.51470067 19.3343514 0.854440142 0.300996693 0.854440142 0.300996693 24.2801075 17.1381951 24.2801075 17.1381951 81.7461977 45.2306946 81.7461977 45.2306946 65.4580384 59.5057106 65.4580384 59.5057106 38.1890975 57.3095543 38.1890975"
          />
          <text
            id="TH10"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="23.959816" y="39.5611987">
              TH10
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH11',
      mockup: (
        <g id="th11" transform="translate(353.000000, 364.000000)">
          <polygon
            id="fill-th1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.7882913 2.44290908 26.5719236 2.44290908 26.5719236 0.978804874 0.218047823 0.978804874 0.218047823 33.1890975 2.41420414 33.1890975 2.41420414 60.4580384 16.1401811 60.4580384 16.1401811 76.7461977 45.7882913 76.7461977"
          />
          <text
            id="TH11"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.6694271" y="36">
              TH11
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH12',
      mockup: (
        <g id="th12" transform="translate(398.000000, 366.000000)">
          <polygon
            id="fill-th12"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="44.5284046 0.442909083 0.788291332 0.442909083 0.788291332 74.7461977 29.1553104 74.7461977 29.1553104 58.4580384 44.4063959 58.4580384"
          />
          <text
            id="TH12"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.416112" y="34">
              TH12
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C1',
      mockup: (
        <g id="c1" transform="translate(211.000000, 218.000000)">
          <polygon
            id="fill-c1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="70.1109155 59.3155654 49.0644175 59.3155654 49.0644175 47.4197187 36.0704927 47.4197187 36.0704927 0.903907842 12.0957862 0.903907842 0.565965589 82.9242457 8.80155177 82.9242457 8.80155177 99.9444572 70.1109155 99.9444572"
          />
          <text
            id="01"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="24.5956329" y="70.1769472">
              01
            </tspan>
          </text>
          <text
            id="C1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="24.0256329" y="85.3297016">
              C1
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B10',
      mockup: (
        <g id="B10" transform="translate(333.000000, 310.000000)">
          <polygon
            id="fill-10"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="54.9905228 0.410420913 0.269627973 0.410420913 0.269627973 30.6075702 2.64879731 30.6075702 2.64879731 41.0393127 54.9905228 41.0393127"
          />
          <text
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="22.3938394" y="22.2189767">
              B10
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B11',
      mockup: (
        <g id="b11" transform="translate(206.000000, 316.000000)">
          <polygon
            id="fill-b11"
            stroke="#0B1A27"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="75.1109155 24.6380724 75.1109155 1.94445716 13.8015518 1.94445716 13.8015518 0.480352947 0.258587831 0.480352947 0.258587831 1.94445716 0.258587831 24.6380724 0.258587831 31.4095544 3.18679625 31.4095544 3.18679625 36.5339191 4.83391348 36.5339191 4.83391348 43.8544401 4.83391348 49.89387 52.0512742 49.89387 52.0512742 53.1881045 71.267642 53.1881045 71.267642 49.89387 71.267642 43.8544401 81.1503454 43.8544401 81.1503454 36.5339191 81.1503454 31.4095544 81.1503454 24.6380724"
          />
          <text
            id="B11"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="26.1894245" y="38.1040362">
              B11
            </tspan>
          </text>
          <text
            id="11"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="30.1674245" y="21.368265">
              11
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B1',
      mockup: (
        <g id="b1" transform="translate(245.000000, 199.000000)">
          <polygon
            id="fill-b1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="36.2939285 12.2478629 39.588163 12.2478629 39.588163 0.0469945061 0.240362399 0.0469945061 0.240362399 19.9039078 2.07049266 19.9039078 2.07049266 66.4197187 21.8358995 66.4197187 21.8358995 65.3216405 36.2939285 65.3216405"
          />
          <text
            id="B1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="13.2879833" y="46.9039078">
              B1
            </tspan>
          </text>
          <text
            id="02"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.0679833" y="30.9039078">
              02
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B2',
      mockup: (
        <g id="b2" transform="translate(281.000000, 199.000000)">
          <polygon
            id="fill-b2"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="44.5830809 0.0469945061 18.7782442 0.0469945061 18.7782442 12.2478629 0.293928549 12.2478629 0.293928549 65.3216405 26.4647913 65.3216405 26.4647913 52.5107287 44.5830809 52.5107287"
          />
          <text
            id="B2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="13.2493614" y="46.9039078">
              B2
            </tspan>
          </text>
          <text
            id="03"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.0293614" y="30.9039078">
              03
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B12',
      mockup: (
        <g id="b12" transform="translate(318.000000, 199.000000)">
          <polygon
            id="fill-b12"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="44.9177382 12.2478629 35.5840739 12.2478629 35.5840739 0.0469945061 7.58308088 0.0469945061 7.58308088 52.5107287 0.628585882 52.5107287 0.628585882 65.3216405 39.7933735 65.3216405 39.7933735 52.5107287 44.9177382 52.5107287"
          />
          <text
            id="B12"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.626" y="46.9039078">
              B12
            </tspan>
          </text>
          <text
            id="04"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="18.6806887" y="30.9039078">
              04
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B14',
      mockup: (
        <g id="b14" transform="translate(517.000000, 358.000000)">
          <polygon
            id="fill-b14"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="71.0237604 0.939375012 0.868767008 0.939375012 0.868767008 44.8625013 59.4329354 44.8625013 59.4329354 28.0253029 71.145769 28.0253029"
          />
          <text
            id="08"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="24.0903751" y="19.89387">
              08
            </tspan>
          </text>
          <text
            id="B14"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="20.1123751" y="35.89387">
              B14
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B13',
      mockup: (
        <g id="b13" transform="translate(506.000000, 324.000000)">
          <polygon
            id="fill-b13"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="82.0237604 13.1608249 70.3109267 13.1608249 70.3109267 0.532926097 0.948989781 0.532926097 0.948989781 34.939375 82.0237604 34.939375"
          />
          <text
            id="07"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="35.0903751" y="14.7162215">
              07
            </tspan>
          </text>
          <text
            id="B13"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="31.1123751" y="30.939375">
              B13
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B13',
      mockup: (
        <g id="b13" transform="translate(506.000000, 290.000000)">
          <polygon
            id="fill-b13"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="82.0237604 0.126477182 0.948989781 0.126477182 0.948989781 34.5329261 70.3109267 34.5329261 70.3109267 21.9050273 82.0237604 21.9050273"
          />
          <text
            id="06"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="35.0903751" y="14.2121568">
              06
            </tspan>
          </text>
          <text
            id="B13-Copy"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="31.1123751" y="30.4409231">
              B13
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B13',
      mockup: (
        <g id="b13" transform="translate(506.000000, 255.000000)">
          <polygon
            id="fill-b13"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="82.0237604 13.3479271 76.7163826 13.3479271 76.7163826 0.506513071 0.948989781 0.506513071 0.948989781 35.278988 82.0237604 35.278988"
          />
          <text
            id="05"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="35.0903751" y="14.6321237">
              05
            </tspan>
          </text>
          <text
            id="B13-Copy-2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="31.1123751" y="30.6321237">
              B13
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B14',
      mockup: (
        <g id="b14" transform="translate(516.000000, 402.000000)">
          <polygon
            id="fill-b14"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="60.3109267 0.862501285 1.74675832 0.862501285 1.74675832 43.3215234 0.0996410885 43.3215234 0.0996410885 47.530823 72.0237604 47.530823 72.0237604 17.6996997 60.3109267 17.6996997"
          />
          <text
            id="09"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="26.7381738" y="19.8383567">
              09
            </tspan>
          </text>
          <text
            id="B14"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="22.7601738" y="34.7461977">
              B14
            </tspan>
          </text>
        </g>
      ),
    },
  ],
  outline: (
    <Fragment>
      <g
        id="streets"
        transform="translate(300.000000, 313.000000)"
        fill="#0B1A27"
        fontFamily="DINOT, DIN OT"
        fontSize="10"
        fontWeight="normal"
      >
        <text id="CLARKSON-ST">
          <tspan x="0" y="170.966278">
            CLARKSON ST
          </tspan>
        </text>
        <text
          id="SIXTH-ST"
          transform="translate(303.822589, 20.500000) rotate(-90.000000) translate(-303.822589, -20.500000) "
        >
          <tspan x="283.322589" y="24.5">
            SIXTH ST
          </tspan>
        </text>
      </g>
      <g
        id="compass"
        transform="translate(563.051950, 473.966278)"
        fill="#0B1A27"
        fillRule="nonzero"
      >
        <polygon
          id="Shape"
          points="10.332078 38.8487477 3.78150781 29.9369255 3.78150781 38.8487477 0.848985112 38.8487477 0.848985112 25.1382519 3.85767723 25.1382519 10.2178239 33.7834812 10.2178239 25.1382519 13.1503466 25.1382519 13.1503466 38.8487477"
        />
        <polygon
          id="Shape"
          points="11.8935511 13.0653988 7.01870819 4.26783067 2.10578055 13.0653988 0.468138008 12.113281 7.01870819 0.345105502 13.5311937 12.113281"
        />
        <rect
          id="Rectangle-path"
          x="6.06659043"
          y="2.32551044"
          width="1.90423552"
          height="21.1370143"
        />
      </g>
      <text
        id="LEVEL-3"
        fontFamily="DINCanfor-Medium, DIN Canfor"
        fontSize="16"
        fontWeight="400"
        fill="#0B1A27"
      >
        <tspan x="303.972" y="597.839844">
          LEVEL 3
        </tspan>
      </text>
      <g
        id="bg-lines"
        transform="translate(36.000000, 164.000000)"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.38"
      >
        <rect
          id="Rectangle-path"
          x="351.990523"
          y="104.164914"
          width="104.500438"
          height="85.6500962"
        />
        <polyline
          id="Shape"
          points="300.380849 146.440923 300.380849 113.864604 351.990523 113.864604"
        />
        <path
          d="M171.356666,152.510855 L171.356666,136.039683 L175.565966,136.039683 M326.185686,31.1732188 L316.302983,31.1732188 L316.302983,35.0164923 M265.242348,35.0164923 L265.242348,31.1427166 L247.27657,31.1427166 L247.27657,34.9859902 M370.108812,21.3515197 L356.748861,21.3515197 M413.848926,21.3515197 L400.671988,21.3515197 M457.406026,21.3515197 L444.412101,21.3515197 M540.310927,238.954008 L552.02376,238.954008 M540.310927,160.624433 L552.02376,160.624433 M552.02376,173.252331 L552.02376,147.905027 M552.02376,255.6997 L552.02376,222.147312 M435.078437,276.746198 L446.242231,276.746198 M391.15531,276.746198 L404.698274,276.746198 M319.048178,260.458038 L319.048178,276.746198 M305.139188,276.746198 L333.140181,276.746198 M221.868261,260.458038 L221.868261,276.746198 M206.312154,276.746198 L237.241355,276.746198 M118.648914,276.746198 L132.191878,276.746198 M74.9088012,276.746198 L88.2687521,276.746198 M30.9856749,276.746198 L44.5286389,276.746198"
          id="Shape"
        />
        <polyline
          id="Shape"
          points="0.788525624 203.724 41.7834435 203.724 41.7834435 188.533919 43.9795998 188.533919"
        />
        <path
          d="M29.3385577,192.163677 L13.2334114,192.163677 M29.3385577,180.633857 L29.3385577,203.693498 M13.2334114,180.664359 L13.2334114,203.724"
          id="Shape"
        />
        <rect
          id="Rectangle-path"
          x="265.425361"
          y="113.315565"
          width="16.8371984"
          height="63.322507"
        />
        <path
          d="M265.577872,133.813024 L282.415071,133.813024 M265.577872,155.561072 L282.415071,155.561072"
          id="Shape"
        />
        <path
          d="M255.725671,162.546069 L255.725671,128.505647 M245.293929,162.546069 L265.577872,162.546069 M245.446439,128.505647 L265.577872,128.505647"
          id="Shape"
        />
        <path
          d="M282.26256,176.638072 L265.577872,155.561072 L282.415071,133.965535 L265.577872,113.315565 M265.577872,176.638072 L282.415071,155.286553 L265.577872,133.813024 L282.415071,113.315565"
          id="Shape"
        />
        <polygon
          id="Path"
          points="265.577872 113.315565 245.110916 113.315565 245.110916 176.638072 265.577872 176.638072"
        />
        <path d="M162.572041,276.746198 L175.931992,276.746198" id="Shape" />
        <polyline
          id="Path"
          points="471.681042 281.321523 470.582964 281.321523 470.582964 243.62084"
        />
        <path d="M448.590898,256.218237 L470.552462,256.218237" id="Path" />
        <path d="M446.150725,272.14037 L470.552462,272.14037" id="Path" />
        <path d="M459.602182,256.065726 L459.602182,271.987859" id="Shape" />
        <polyline
          id="Shape"
          points="209.240362 34.9859902 196.063425 34.9859902 196.063425 54.93441"
        />
        <polyline
          id="Path"
          points="470.94899 91.5065131 459.236156 91.5065131 459.236156 90.5914479"
        />
        <polyline
          id="Path"
          points="446.242231 260.610549 446.242231 284.768269 471.681042 284.768269 471.681042 281.321523 480.099641 281.321523"
        />
        <polyline
          id="Path"
          points="43.9185955 188.533919 43.9185955 180.664359 0.788525624 180.664359 0.788525624 203.724"
        />
        <polyline
          id="Shape"
          points="546.716383 91.3540022 546.716383 77.9940513 552.02376 77.9940513 552.02376 21.0770002 542.32407 20.5279611 531.709314 9.91320558 530.977262 0.579541249 457.406026 0.579541249 457.406026 32.4238078"
        />
        <path d="M271.464791,100.32164 L282.628586,100.32164" id="Shape" />
        <rect
          id="Rectangle-path"
          x="450.634544"
          y="205.737144"
          width="19.9484198"
          height="6.58846894"
        />
        <path d="M230.835899,113.315565 L230.835899,101.419719" id="Shape" />
        <polyline
          id="Path"
          points="269.085622 188.899945 269.085622 195.85444 251.150345 195.85444 251.150345 188.899945"
        />
        <polyline
          id="Path"
          points="269.085622 188.899945 279.334351 188.899945 279.334351 195.85444 269.085622 195.85444 269.085622 188.899945 251.150345 188.899945"
        />
      </g>
    </Fragment>
  ),
};



// WEBPACK FOOTER //
// ./src/data/floorplates/svg/level3.js